import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const MinimumSpanningTreeModule = () => (
  <DMModuleSubtopic
    title="Minimum Spanning Tree"
    videos={[
      "https://www.youtube.com/embed/XInyXs1s3Wg",
      "https://www.youtube.com/embed/dtvoe_Ixum4",
      "https://www.youtube.com/embed/ToACXUBwouc"
    ]}
    takeaways={[]}
    questions={[
        {image:"/dm_53.png"},
        {image:"/dm_54.png"},
        {image:"/dm_55.png"},
        {image:"/dm_56.png"},
        {image:"/dm_57.png"},
    ]}
    exampleVideos={[]}
  />
);

export default MinimumSpanningTreeModule;
